var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "381AAA61-38B0-4F22-822E-11F8A66BDE93") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-727.000000, -376.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button-Group",
    transform: "translate(727.000000, 376.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-9",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    x: 0,
    y: 0,
    width: 119,
    height: 24.3913043
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-281",
    fill: "#E1E1E1",
    fillRule: "evenodd",
    x: 62,
    y: 5,
    width: 52.1086957,
    height: 15.1521739,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-281",
    fill: "#000000",
    fillRule: "evenodd",
    x: 5,
    y: 5,
    width: 52.1086957,
    height: 15.1521739,
    rx: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "Right-Button",
    fill: "none",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 6,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 69,
    y: 15,
    fill: "#000000"
  }, " Right Button")), /*#__PURE__*/React.createElement("text", {
    id: "Left-Button",
    fill: "none",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 6,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 14,
    y: 15,
    fill: "#FFFFFF"
  }, "Left Button")))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonGroup);
export default __webpack_public_path__ + "static/media/ButtonGroup.0107318b2a13ad5bbe0d14317304fb45.svg";
export { ForwardRef as ReactComponent };